<template>
	<div class="game_detail_wrapper">
		<div class="game_detail_container">
            <div class="game_detail_main">
                <div class="game_info">
                    <div class="game_icon">
                        <img :src="currentGame.icon" alt="" />
                    </div>
                    <div class="game_name">
                        <p>{{ currentGame.game_name_cn }}</p>
                        <p v-if="false">
                            <template v-for="(countryCode, index) in currentGame.country">
                                {{ index > 0 ? '/' : '' }}{{ $t('index.country.' + countryCode) }}
                            </template>
                        </p>
                    </div>
                </div>

                <div class="game_desc_box">
                    <div class="game_desc">
                        <div class="desc_sty">
                            <p>{{ $t('index.game_introduction') }}</p>
                            <span v-if="false">{{ getTranslation('index.game_introduction_arr.' + currentGame.game_id) }}</span>
                            <span>{{ currentGame.introduce }}</span>
                        </div>

                        <div class="desc_sty">
                            <p>{{ $t('index.how_to_play') }}</p>
                            <span v-if="false">{{ getTranslation('index.how_to_play_arr.' + currentGame.game_id) }}</span>
                            <span>{{ currentGame.desc }}</span>
                        </div>

                        <div class="desc_sty" v-if="false">
                            <p>{{ $t('index.support_language') }}</p>
                            <span class="lang">
                                <template v-for="(languageCode, index) in currentGame.language">
                                    {{ index > 0 ? '/' : '' }}{{ $t('index.support_language_arr.' + languageCode) }}
                                </template>
                            </span>
                        </div>

                        <div class="warning_sty">
                            <p>{{ $t('index.warning_tips') }}</p>
                        </div>
                    </div>

                    <div class="game_video">
                        <video 
                            v-if="currentGame.video !== null" 
                            ref="detailBannerVideo" 
                            :poster="gameDetailViewPoster" 
                            :autoplay="true" 
                            :loop="true" 
                            data-object-fit="true" 
                            controls 
                            muted>
                            <source :src="currentGame.video" type="video/mp4">
                            Sorry, your browser does not support embedded videos.
                        </video>
                        <img 
                            v-else 
                            v-lazy="currentGame.interface[0]" alt="" /><!-- currentGame.screen_shot[0] -->
                    </div>
                </div>
            </div>

            <div class="shot_wrapper">
                <div>{{ $t('index.game_screenshot_tips') }}</div>
                <div>
                    <img 
                        v-for="(item, index) in currentGame.interface" :key="'gss_' + index" 
                        class="shot_img" 
                        v-lazy="item" alt="" />
                </div>
            </div>
        </div>

        <GlobalDeploymentPc />

        <FooterMenuPc />

        <!-- DEMO -->
		<DemoDialogPc />
    </div>
</template>

<script>
import gameDetailViewPoster from '@/../public/static/imgs/gameDetailViewPosterMobile01.png';

import GlobalDeploymentPc   from '@/components/pc/GlobalDeployment.vue';
import FooterMenuPc         from '@/components/pc/FooterMenu.vue';
import DemoDialogPc         from '@/components/pc/DemoDialog.vue';

import { mapState }            from 'vuex';
import { goToHome }            from '@/utils/routerUtils';
import { fetchAllGamesCached } from '@/api/gameDataLoader';
import {
	NAV_IS_PAGE_SCROLL,
	DEMO_DIALOG_IS_SHOW
} from '@/type/mutation';

export default {
	name      : 'GameDetailPc',
    components: {
		GlobalDeploymentPc,
        FooterMenuPc,
        DemoDialogPc
	},
    data() {
		return {
            // currentGameId: this.$store.state.currentGameId,
            gameDetailViewPoster,
            currentGameId: 0,
            currentKey   : '',
			currentGame  : {},
			allGames     : []
        };
    },

    created() {
        this.currentGameId = parseInt(this.$route.params.game_id);
        this.currentKey    = String(this.$route.params.key);
        // console.log('=== GameDetailView__PC__created__currentGameId >>>', this.currentGameId);
        // console.log('=== GameDetailView__PC__created__currentKey >>>', this.currentKey);

        // 首次由列表页跳转过来
        if(Number(this.currentGameId) !== 0 && String(this.currentKey) !== '')
        {
            let sign = this.$Common.makeSign(this, this.currentGameId);
            if(sign !== this.currentKey)
            {
                this.goHome();
            }
            else
            {
				// 加载数据并初始化
				this.loadAllGamesAndInit();

                localStorage.setItem('_gid', this.currentGameId);
                localStorage.setItem('_key', this.currentKey);
            }
        }
        else
        {
            let _gid = localStorage.getItem('_gid');
            let _key = localStorage.getItem('_key');
            if(_gid && _key)
            {
                this.currentGameId = parseInt(_gid);
                this.currentKey    = String(_key);
                this.loadAllGamesAndInit();
            }
            else
            {
                this.goHome();
            }
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        this.$store.commit(NAV_IS_PAGE_SCROLL, true);
    },

    methods: {
        /**
         * 获取翻译内容的公共方法
         * @param   {string} key - 翻译键名，例如：'index.game_introduction_arr.2041'
         * @returns {string}     - 如果翻译键存在则返回翻译内容，否则返回空字符串
         */
        getTranslation(key)
        {
            return this.$te(key) ? this.$t(key) : '暂无';
        },

        // 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

        // 二级页面点击导航，打开DEMO弹窗
		openDemoDialog(value)
		{
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);
		},

        // 跳转至首页
        goHome()
		{
			goToHome(this.$router);
		},

		// 加载 allGames（缓存优先，无则请求），并初始化当前游戏
		async loadAllGamesAndInit()
		{
			try {
				this.allGames = await fetchAllGamesCached();
				this.initializeCurrentGame();
			}
            catch(err) {
				console.error('=== GameDetail__loadAllGamesAndInit__load failed >>>', err);
			}
		},

        initializeCurrentGame()
        {
			if(this.allGames.length > 0 && Number(this.currentGameId) !== 0)
            {
                this.currentGame = this.getGameObj(this.currentGameId);
                // console.log('=== GameDetailView__initializeCurrentGame__currentGame >>>', this.currentGame);
            }
            else
            {
                // console.log('=== GameDetailView__initializeCurrentGame__Vuex状态未初始化__或currentGameId无效 <<<');
            }
        },

        // 获取单个游戏对象
		getGameObj(currentGameId)
        {
            // console.log('=== GameDetailView__getGameObj__currentGameId >>>', currentGameId);
            // console.log('=== GameDetailView__getGameObj__this.allGames >>>', this.allGames);

			let currentGame = this.allGames.filter(
                game => String(game.game_id) === String(currentGameId)
            );
            // console.log('=== GameDetailView__getGameObj__currentGame >>>', currentGame);

            this.$nextTick(() => {
                // Reload the video element to apply the new source
                if(this.$refs.detailBannerVideo && typeof this.$refs.detailBannerVideo.load === 'function')
                {
                    this.$refs.detailBannerVideo.load();
                }
                else
                {
                    console.warn('detailBannerVideo does not exist');
                }
            });

            return currentGame[0];
        }
    },

    watch: {
        allGames(newAllGames) {
            this.initializeCurrentGame();
        },

        '$route.params.game_id': async function(newGameId, oldGameId) {
            this.currentGameId = parseInt(newGameId);
            if(!this.allGames.length)
            {
                await this.loadAllGamesAndInit();
            }
            else
            {
                this.currentGame = this.getGameObj(this.currentGameId);
            }
        }
    },

	computed: {
		// ES6展开合并运算符
		...mapState(['isNavBgColorful', 'isShowMobileMenu', 'isHideForTest'])
	},

    beforeDestroy() {
		// window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.game_detail_wrapper{
	width:100%;height:auto;
	padding-top:0;
    background:linear-gradient(135deg, rgba(210, 223, 244, 1), rgba(236, 243, 255, 1), rgba(225, 240, 255, 1), rgba(243, 240, 255, 1));
    .game_detail_container{
        display:flex;flex-direction:column;justify-content:center;align-items:center;
        width:inherit;height:inherit;
        background:url(@/assets/static/imgs/home/bg-player.png) left bottom no-repeat;/* #E6F0FF */
		background-size:374px 400px;
        .game_detail_main{
            width:var(--com-base-container-w);height:inherit;
            padding-top:130px;padding-bottom:65px;
            .game_info{
                display:flex;justify-content:flex-start;align-items:center;
                padding-left:50px;
                .game_icon{
                    width:130px;height:130px;
                    border-radius:25px;
                    box-shadow:0 0 20px 0 #a1befc;
                    img{
                        width:inherit;height:inherit;
                        border-radius:inherit;
                    }
                }
                .game_name{
                    padding-left:30px;
                    p:nth-child(1){
                        font-size:var(--com-base-fz-48);color:var(--com-main-ft-color);font-weight:bold;
                    }
                    p:nth-child(2){
                        font-family:var(--com-number-coin-fm-R);font-size:var(--com-base-fz-22);color:#676D77;font-weight:normal;
                    }
                }
            }
            .game_desc_box{
                position:relative;
                width:var(--com-base-container-w);height:460px;
                border-radius:18px;border:2px solid #FFF;
                background:#F2F7FF;
                margin-top:60px;padding:40px 50px;
                .game_desc{
                    height:380px;
                    display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;
                    /* gap:50px; */
                    .desc_sty{
                        p{
                            font-size:var(--com-base-fz-22);color:#5B77A1;font-weight:bold;
                        }
                        span{
                            font-size:var(--com-base-fz-18);color:#8798B1;font-weight:normal;
                            line-height:1.5;
                            display:block;
                            width:980px;height:90px;
                            margin-top:5px;padding:0;
                        }
                        span.lang{
                            font-family:var(--com-number-coin-fm-R);height:70px;
                        }
                    }
                    .warning_sty{
                        p{
                            font-size:var(--com-base-fz-16);color:#1D55FF;
                        }
                    }
                }
                .game_video{
                    position:absolute;top:-40px;right:90px;
                    width:270px;height:536px;
                    border:6px solid #ffffff;border-radius:32px;
                    box-shadow:0 4px 20px 0 rgba(0, 0, 0, .15);
                    video{
                        width:100%;height:100%;border-radius:23px;
                        object-fit:cover;
                    }
                    img{
                        width:100%;height:100%;border-radius:23px;
                        object-fit:cover;
                    }
                }
            }
        }
        .shot_wrapper{
            width:var(--com-base-container-w);height:auto;
            padding-bottom:100px;
            div:nth-child(1){
                width:100%;height:90px;line-height:100px;
                font-size:var(--com-base-fz-48);color:var(--com-main-ft-color);font-weight:bold;text-align:center;
                img{
                    width:100%;height:100%;
                    object-fit:cover;
                }
            }
            div:nth-child(2){
                margin-top:30px;
                display:flex;justify-content:space-between;align-items:flex-start;
                img{
                    width:270px;height:536px;
                    border-radius:23px;border:5px solid #FFF;
                    object-fit:cover;
                    box-shadow:0 4px 20px 0 rgba(0, 0, 0, .15);
                }
            }
        }
    }
}
</style>
